import loanFormModel from '../../form_models/loanFormModel';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import * as Yup from 'yup';
import { RulesetResult } from '../../business/rules';
import { SystemPropertyEstimationMethodRuleset } from '../../business/ruleset/solar_property';

const { systemPropertyEstimationMethod } = loanFormModel.formField;

export class SystemPropertyEstimationMethodValidation
  implements ValidationSchema
{
  public name: string = systemPropertyEstimationMethod.name;
  public label = '';
  public dependsOn: string[] = SystemPropertyEstimationMethodRuleset.dependsOn;
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;
  public ruleset = SystemPropertyEstimationMethodRuleset;

  public when(...args: any[]) {
    const result: RulesetResult = args.pop();
    const schema: Yup.StringSchema = args[this.dependsOn.length];
    if (result & RulesetResult.REQUIRED)
      return schema.required('This field is required');
    return schema;
  }
}
export default new Validation(new SystemPropertyEstimationMethodValidation());
